import { Autocomplete, Button, FormControl, Table, IconButton, MenuItem, Select, TableCell, TableHead, TableRow, Typography, TableBody, TablePagination, TextField, Stack, Dialog, DialogContent, RadioGroup, FormControlLabel, Radio } from '@mui/material'
import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-react'
import { Box } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { ApiDownloadAllAsXlsInImportExportAllocation, ApiDownloadExcelForOrphanInImportExportAllocation, ApiDownloadPdfByStatusInImportExportAllocation, ApiDownloadShopperAppliedAllocationsExcel, ApiGetRoasterMaster, ApiImportExportAllocationPoints, ApiImportExportAllocationTable } from '../../../apiService/Core/Apicall.tsx'
import { RootState } from '../../../global/config/store.ts'
import { useDispatch, useSelector } from 'react-redux'
import { setSelectedClientGroup } from '../../../global/config/Reducer/clientSlice.ts'
import { setDate } from '../../../global/config/Reducer/dateSlice.ts'
import { CancelOutlined } from '@mui/icons-material'
import { date } from 'yup'
import { toast } from 'react-toastify'


function ImportExportAllocations() {
    const selectedClientName = useSelector((state: RootState) => state.client.selectedClient)
    const selectedDateRedux = useSelector((state: RootState) => state.date.selectedDate)
    const dispatch = useDispatch()
    const [currentDate, setCurrentDate] = useState(new Date(selectedDateRedux))
    const [status, setstatus] = useState<string>('created')
    const [datalength, setdatalength] = useState<any>(null);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(50);
    const [allocationTable, setallocationTable] = useState<any>([]);
    const [allocationPoints, setallocationPoints] = useState<any>([]);
    const Clientlist = useSelector((state: RootState) => state.client.clientList)
    const [selectedClient, setSelectedClient] = useState<any>(selectedClientName)
    const [ClientId, setClientId] = useState(null)
    const [selectedOption, setselectedOption] = useState('true')
    const [OpenRoasterDownload, setOpenRoasterDownload] = useState<boolean>(false)
    const timestamp = new Date()
        .toISOString()
        .replace(/[-:T.Z]/g, '')  // remove all non-numeric symbols
        .slice(0, 14); // keep only YYYYMMDDHHMMSS

    // ------------------------------------------- Chnage Pagination -----------------------------------------------
    const handleChangePage = (_event: unknown, newPage: number) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (
        event: React.ChangeEvent<HTMLInputElement>
    ) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };


    const tabledata = async () => {
        setallocationTable([])
        try {
            const data = `?jobMonth=${currentDate.getMonth() + 1}&jobYear=${currentDate.getFullYear()}&allocationStatus=${status}&offset=${rowsPerPage * page}&limit=${rowsPerPage}`
            const res = await ApiImportExportAllocationTable(data)
            setallocationTable(res.data)
            setdatalength(res.totalDataCount)


        } catch (error) {
            alert(error)
        }
    }

    const ponitsdata = async () => {
        try {
            const data = `?jobMonth=${currentDate.getMonth() + 1}&jobYear=${currentDate.getFullYear()}`
            const res = await ApiImportExportAllocationPoints(data)
            setallocationPoints(res.data)

        } catch (error) {
            alert(error)
        }
    }
    useEffect(() => {
        ponitsdata()
        tabledata()
    }, [currentDate, status, rowsPerPage, page])
    const handlePrevMonth = () => {
        setCurrentDate((prevDate) => {
            const newDate = new Date(prevDate.getFullYear(), prevDate.getMonth() - 1, 1)
            const jobMonth = newDate.getMonth() + 1
            const jobYear = newDate.getFullYear()
            dispatch(setDate(newDate))
            // setCurrentPage(1) // Reset to first page when changing month
            // handleGetAppliedAllocation(jobMonth, jobYear)
            return newDate
        })
    }
    const handleNextMonth = () => {
        setCurrentDate((prevDate) => {
            const newDate = new Date(prevDate.getFullYear(), prevDate.getMonth() + 1, 1)
            const jobMonth = newDate.getMonth() + 1
            const jobYear = newDate.getFullYear()
            dispatch(setDate(newDate))
            // setCurrentPage(1) // Reset to first page when changing month
            // handleGetAppliedAllocation(jobMonth, jobYear)
            return newDate
        })
    }

    const handleDateChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const newDate = new Date(event.target.value + "-01")
        setCurrentDate(newDate)

        const jobMonth = newDate.getMonth() + 1
        const jobYear = newDate.getFullYear()
        dispatch(setDate(event.target.value))
        // setCurrentPage(1) // Reset to first page when date changes
        // handleGetAppliedAllocation(jobMonth, jobYear)
    }

    useEffect(() => {
        if (selectedDateRedux) {
            setCurrentDate(new Date(selectedDateRedux))
        }
    }, [selectedDateRedux])

    const formatDate = (date: Date) => {
        return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}`
    }
    const Status = () => {
        switch (status) {
            case 'created':
                return 'Created'
                break;

            case 'shopper_applied':
                return 'Shopper Applied'
                break;

            case 'approve':
                return 'Approve'
                break;

            case 'completed':
                return 'Completed'
                break;

            case 'rejected':
                return 'Rejected'
                break;

            case 'hold':
                return 'Hold'
                break;

            case 'recheck':
                return 'Recheck'
                break;

            case 'applied':
                return 'Applied'
                break;

            case 'cancelled':
                return 'Cancel'
                break;

            default:
                return "Not Found"
                break;
        }
    }
    const handleDownloadAllAsXls = async () => {
        try {
            const data = `?jobMonth=${currentDate.getMonth() + 1}&jobYear=${currentDate.getFullYear()}&allocationClientGroup=${selectedClient.clientGroupName}`
            const res = await ApiDownloadAllAsXlsInImportExportAllocation(data);

            const blob = new Blob([res], {
                type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            });
            const url = URL.createObjectURL(blob);

            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `importExportAllAllocation_${timestamp}.xlsx`);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        } catch (error) {
            alert(error)
        }
    }
    const handleDownloadAsXls = async () => {
        try {
            const data = `?jobMonth=${currentDate.getMonth() + 1}&jobYear=${currentDate.getFullYear()}&status=${status}${selectedClient?.clientGroupName ? `&allocationClientGroup=${selectedClient.clientGroupName}` : ''}`
            const res = await ApiDownloadAllAsXlsInImportExportAllocation(data);

            const blob = new Blob([res], {
                type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            });
            const url = URL.createObjectURL(blob);

            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `importExportAllAllocation.xlsx`);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        } catch (error) {
            alert(error)
        }
    }
    const handleDownloadAsPDF = async () => {
        try {
            const data = `?jobMonth=${currentDate.getMonth() + 1}&jobYear=${currentDate.getFullYear()}&status=${status}${selectedClient?.clientGroupName ? `&allocationClientGroup=${selectedClient.clientGroupName}` : ''}`
            const res = await ApiDownloadPdfByStatusInImportExportAllocation(data);

            const blob = new Blob([res], {
                type: 'application/pdf',
            });
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;

            link.download = 'importExportAllocation.pdf';
            document.body.appendChild(link);
            link.click();

            link.remove();
            window.URL.revokeObjectURL(url)

        } catch (error) {
            alert(error)
        }
    }
    const handleDownloadOrphan = async () => {
        try {
            let data = `?jobMonth=${currentDate.getMonth() + 1}&jobYear=${currentDate.getFullYear()}`
            if (selectedClient?.clientGroupName !== 'All')
                data += `&allocationClientGroup=${selectedClient.clientGroupName}`;
            const res = await ApiDownloadExcelForOrphanInImportExportAllocation(data);

            const blob = new Blob([res], {
                type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            });
            const url = URL.createObjectURL(blob);

            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `OrphanAllocations_${timestamp}.xlsx`);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        } catch (error) {
            toast.error("No allocation found for this month.")
        }
    }


    const handledownloadRoaster = async () => {
        try {
            let data = `?jobMonth=${currentDate.getMonth() + 1}&jobYear=${currentDate.getFullYear()}&isNameNumber=${selectedOption}`
            if (selectedClient?.clientGroupName !== 'All')
                data += `&allicationGroupName=${selectedClient.clientGroupName}`;

            const res = await ApiGetRoasterMaster(data)
            const blob = new Blob([res], {
                type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            });
            const url = URL.createObjectURL(blob);

            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `RosterMaster_${timestamp}.xlsx`);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        } catch (error) {
            alert(error)
        }
    }

    const handleDownloadAppliedAllocation = async () => {
        try {
            let data = `?jobMonth=${currentDate.getMonth() + 1}&jobYear=${currentDate.getFullYear()}`
            if (selectedClient?.clientGroupName !== 'All')
                data += `&clientGroupName=${selectedClient.clientGroupName}`;
            const res = await ApiDownloadShopperAppliedAllocationsExcel(data);
            const blob = new Blob([res], {
                type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            });
            const url = URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `ShopperAppliedAllocations_${timestamp}.xlsx`);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        } catch (error) {
            alert(error)
        }
    }


    return (
        <div style={{ backgroundColor: 'white', padding: "20px !important", overflow: 'hidden' }}>
            <h2 className='text-center mt-4' style={{ fontWeight: '600' }}> Import Export Allocations</h2>
            <Box className='d-flex px-2 mt-4  align-items-center justify-content-between'>
                <Box display="flex" alignItems='center' gap={1}>
                    <FormControl size="small" sx={{ width: 200 }}>
                        <label htmlFor="status" className='mb-0 pl-1' style={{ fontSize: '12px' }}>Status</label>
                        <Select value={status} id='status' onChange={(e) => { setstatus(e.target.value) }}>
                            <MenuItem value="created">Created</MenuItem>
                            <MenuItem value="shopper_applied">Shopper Applied</MenuItem>
                            <MenuItem value="approved">Approve</MenuItem>
                            <MenuItem value="completed">Completed</MenuItem>
                            <MenuItem value="rejected">Rejected</MenuItem>
                            <MenuItem value="hold">Hold</MenuItem>
                            <MenuItem value="recheck">Recheck</MenuItem>
                            <MenuItem value="applied">Applied</MenuItem>
                            <MenuItem value="cancelled">Cancel</MenuItem>
                        </Select>
                    </FormControl>
                    <Stack className="ml-2" direction="row" spacing={2}>
                        <FormControl size="small" sx={{ width: 200 }}>
                            <label htmlFor="" className='mb-0' style={{ fontSize: '12px' }}>Selected Client</label>
                            <Autocomplete
                                disablePortal
                                id="mm-autocomplete"
                                options={[...Clientlist, { clientGroupName: "All", clientGroupDBName: "all" },]}
                                value={selectedClient}
                                getOptionLabel={(option) => option?.clientGroupName || ""}
                                isOptionEqualToValue={(option, value) =>
                                    option.clientGroupDBName === value.clientGroupDBName
                                }
                                onChange={(event, newValue: any) => {
                                    setSelectedClient(newValue || null);

                                    if (newValue?.clientGroupDBName !== "all") {
                                        dispatch(setSelectedClientGroup(newValue));
                                        setClientId(newValue?.clientGroupName || null);
                                    }
                                }}
                                renderInput={(params) => <TextField {...params} label="" />}
                                size="small"
                            />
                        </FormControl>
                    </Stack>
                </Box>
                <Box
                    sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        // marginBottom: "70px",
                    }}
                >
                    <IconButton onClick={handlePrevMonth}>
                        <ChevronLeftIcon />
                    </IconButton>
                    <Box sx={{ display: "flex", alignItems: "center", mx: 2 }}>
                        <input
                            type="month"
                            value={formatDate(currentDate)}
                            onChange={handleDateChange}
                            className="primary-color"
                            style={{
                                border: "none",
                                background: "none",
                                fontSize: "1.25rem",
                                fontWeight: "bold",
                                cursor: "pointer",
                                fontFamily: "inherit",
                            }}
                        />
                    </Box>
                    <IconButton onClick={handleNextMonth}>
                        <ChevronRightIcon />
                    </IconButton>
                </Box>
            </Box>

            <Box className='d-flex mt-4 mx-5 extra align-items-center justify-content-center' gap={2}>
                {/* <Button
                    fullWidth
                    sx={{ color: 'white' }}
                    className="action-button  action-button--approve table-row-background"
                    onClick={() => handleDownloadAsPDF()}
                >
                    DOWNLOAD AS PDF
                </Button>
                <Button
                    fullWidth
                    sx={{ color: 'white' }}
                    className="action-button  action-button--approve table-row-background"
                    onClick={() => handleDownloadAsXls()}                >
                    DOWNLOAD AS XLS
                </Button>*/}
                <Button
                    onClick={() => { setOpenRoasterDownload(true) }}
                    // fullWidth
                    sx={{ color: 'white' }}
                    className="action-button px-5  action-button--approve table-row-background"
                // onClick={() => handleUpdateAppliedAllocation(shopperApplied, "approved")}
                >
                    Roster Master
                </Button>
                <Button
                    // fullWidth
                    sx={{ color: 'white' }}
                    className="action-button px-5 action-button--approve table-row-background"
                    onClick={() => handleDownloadAllAsXls()}
                >
                    DOWNLOAD ALL AS XLS
                </Button>
                {/* <Button
                    // fullWidth
                    sx={{ color: 'white' }}
                    className="action-button px-5 action-button--approve table-row-background"
                // onClick={() => handleUpdateAppliedAllocation(shopperApplied, "approved")}
                >
                    Roster
                </Button> */}
                <Button
                    // fullWidth
                    sx={{ color: 'white' }}
                    className="action-button px-5 action-button--approve table-row-background"
                    onClick={() => handleDownloadOrphan()}
                >
                    Orphan
                </Button>
                <Button
                    sx={{ color: 'white' }}
                    className="action-button px-5 action-button--approve table-row-background"
                    onClick={() => handleDownloadAppliedAllocation()}
                >
                    Shopper Applied
                </Button>

            </Box>
            <Box className='p-2 mx-2 text-light my-3' borderRadius='5px' bgcolor={'#7a7d52'}>
                <Typography fontWeight='bold' variant='h6'>Total Reports: {(Number(allocationPoints?.MM?.totalReports) + Number(allocationPoints?.ALDI?.reduce((sum: any, item: any) => sum + (Number(item?.totalReports) || 0), 0) || 0) + Number(allocationPoints?.TRANSPORT?.totalReports) + Number(allocationPoints?.BLOOMS?.totalReports))}</Typography>
            </Box>
            <Box className='mx-2'>
                <Table>
                    <TableHead sx={{ bgcolor: "#7a7d52" }}>
                        <TableRow>
                            <TableCell className='text-light text-center py-4' sx={{ fontSize: '20px', fontWeight: 'bolder' }}>Site name</TableCell>
                            <TableCell className='text-light text-center py-4' sx={{ fontSize: '20px', fontWeight: 'bolder' }}>Total Jobs</TableCell>
                            <TableCell className='text-light text-center py-4' sx={{ fontSize: '20px', fontWeight: 'bolder' }}>Allocated</TableCell>
                            <TableCell className='text-light text-center py-4' sx={{ fontSize: '20px', fontWeight: 'bolder' }}>Pending Approval</TableCell>
                            <TableCell className='text-light text-center py-4' sx={{ fontSize: '20px', fontWeight: 'bolder' }}>Orphan</TableCell>
                            <TableCell className='text-light text-center py-4' sx={{ fontSize: '20px', fontWeight: 'bolder' }}>Completed</TableCell>
                            <TableCell className='text-light text-center py-4' sx={{ fontSize: '20px', fontWeight: 'bolder' }}>Pending</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {allocationPoints?.ALDI?.map((item) => (
                            <TableRow>
                                <TableCell className='text-light text-center py-4' sx={{ fontSize: '20px', fontWeight: 'bolder', bgcolor: "#7a7d52" }}>{item?.entityName}</TableCell>
                                <TableCell className='text-center' sx={{ fontSize: '20px', fontWeight: 'bolder' }}>{item?.totalJobs}</TableCell>
                                <TableCell className='text-center' sx={{ fontSize: '20px', fontWeight: 'bolder' }}>{item?.allocated}</TableCell>
                                <TableCell className='text-center' sx={{ fontSize: '20px', fontWeight: 'bolder' }}>{item?.pendingApproval}</TableCell>
                                <TableCell className='text-center' sx={{ fontSize: '20px', fontWeight: 'bolder' }}>{item?.orphan}</TableCell>
                                <TableCell className='text-center' sx={{ fontSize: '20px', fontWeight: 'bolder' }}>{item?.completed}</TableCell>
                                <TableCell className='text-center' sx={{ fontSize: '20px', fontWeight: 'bolder' }}>{item?.pending}</TableCell>
                            </TableRow>

                        ))}
                        <TableRow>
                            <TableCell className='text-light text-center py-4' sx={{ fontSize: '20px', fontWeight: 'bolder', bgcolor: "#7a7d52" }}>BLOOMS</TableCell>
                            <TableCell className='text-center' sx={{ fontSize: '20px', fontWeight: 'bolder' }}>{allocationPoints?.BLOOMS?.totalJobs}</TableCell>
                            <TableCell className='text-center' sx={{ fontSize: '20px', fontWeight: 'bolder' }}>{allocationPoints?.BLOOMS?.allocated}</TableCell>
                            <TableCell className='text-center' sx={{ fontSize: '20px', fontWeight: 'bolder' }}>{allocationPoints?.BLOOMS?.pendingApproval}</TableCell>
                            <TableCell className='text-center' sx={{ fontSize: '20px', fontWeight: 'bolder' }}>{allocationPoints?.BLOOMS?.orphan}</TableCell>
                            <TableCell className='text-center' sx={{ fontSize: '20px', fontWeight: 'bolder' }}>{allocationPoints?.BLOOMS?.completed}</TableCell>
                            <TableCell className='text-center' sx={{ fontSize: '20px', fontWeight: 'bolder' }}>{allocationPoints?.BLOOMS?.pending}</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell className='text-light text-center py-4' sx={{ fontSize: '20px', fontWeight: 'bolder', bgcolor: "#7a7d52" }}>MM</TableCell>
                            <TableCell className='text-center' sx={{ fontSize: '20px', fontWeight: 'bolder' }}>{allocationPoints?.MM?.totalJobs}</TableCell>
                            <TableCell className='text-center' sx={{ fontSize: '20px', fontWeight: 'bolder' }}>{allocationPoints?.MM?.allocated}</TableCell>
                            <TableCell className='text-center' sx={{ fontSize: '20px', fontWeight: 'bolder' }}>{allocationPoints?.MM?.pendingApproval}</TableCell>
                            <TableCell className='text-center' sx={{ fontSize: '20px', fontWeight: 'bolder' }}>{allocationPoints?.MM?.orphan}</TableCell>
                            <TableCell className='text-center' sx={{ fontSize: '20px', fontWeight: 'bolder' }}>{allocationPoints?.MM?.completed}</TableCell>
                            <TableCell className='text-center' sx={{ fontSize: '20px', fontWeight: 'bolder' }}>{allocationPoints?.MM?.pending}</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell className='text-light text-center py-4' sx={{ fontSize: '20px', fontWeight: 'bolder', bgcolor: "#7a7d52" }}>Transport</TableCell>
                            <TableCell className='text-center' sx={{ fontSize: '20px', fontWeight: 'bolder' }}>{allocationPoints?.TRANSPORT?.totalJobs}</TableCell>
                            <TableCell className='text-center' sx={{ fontSize: '20px', fontWeight: 'bolder' }}>{allocationPoints?.TRANSPORT?.allocated}</TableCell>
                            <TableCell className='text-center' sx={{ fontSize: '20px', fontWeight: 'bolder' }}>{allocationPoints?.TRANSPORT?.pendingApproval}</TableCell>
                            <TableCell className='text-center' sx={{ fontSize: '20px', fontWeight: 'bolder' }}>{allocationPoints?.TRANSPORT?.orphan}</TableCell>
                            <TableCell className='text-center' sx={{ fontSize: '20px', fontWeight: 'bolder' }}>{allocationPoints?.TRANSPORT?.completed}</TableCell>
                            <TableCell className='text-center' sx={{ fontSize: '20px', fontWeight: 'bolder' }}>{allocationPoints?.TRANSPORT?.pending}</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell className='text-light text-center py-4' sx={{ fontSize: '20px', fontWeight: 'bolder', bgcolor: "#7a7d52" }}>Extended</TableCell>
                            <TableCell className='text-center' sx={{ fontSize: '20px', fontWeight: 'bolder' }}>{allocationPoints?.EXTENDED?.totalJobs}</TableCell>
                            <TableCell className='text-center' sx={{ fontSize: '20px', fontWeight: 'bolder' }}>{allocationPoints?.EXTENDED?.allocated}</TableCell>
                            <TableCell className='text-center' sx={{ fontSize: '20px', fontWeight: 'bolder' }}>{allocationPoints?.EXTENDED?.pendingApproval}</TableCell>
                            <TableCell className='text-center' sx={{ fontSize: '20px', fontWeight: 'bolder' }}>{allocationPoints?.EXTENDED?.orphan}</TableCell>
                            <TableCell className='text-center' sx={{ fontSize: '20px', fontWeight: 'bolder' }}>{allocationPoints?.EXTENDED?.completed}</TableCell>
                            <TableCell className='text-center' sx={{ fontSize: '20px', fontWeight: 'bolder' }}>{allocationPoints?.EXTENDED?.pending}</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell className='text-light text-center py-4' sx={{ fontSize: '20px', fontWeight: 'bolder', bgcolor: "#7a7d52" }}>JBHIFI</TableCell>
                            <TableCell className='text-center' sx={{fontSize: '20px', fontWeight: 'bolder' }}>{allocationPoints?.JBHIFI?.totalJobs}</TableCell>
                            <TableCell className='text-center' sx={{fontSize: '20px', fontWeight: 'bolder' }}>{allocationPoints?.JBHIFI?.allocated}</TableCell>
                            <TableCell className='text-center' sx={{fontSize: '20px', fontWeight: 'bolder' }}>{allocationPoints?.JBHIFI?.pendingApproval}</TableCell>
                            <TableCell className='text-center' sx={{fontSize: '20px', fontWeight: 'bolder' }}>{allocationPoints?.JBHIFI?.orphan}</TableCell>
                            <TableCell className='text-center' sx={{fontSize: '20px', fontWeight: 'bolder' }}>{allocationPoints?.JBHIFI?.completed}</TableCell>
                            <TableCell className='text-center' sx={{fontSize: '20px', fontWeight: 'bolder' }}>{allocationPoints?.JBHIFI?.pending}</TableCell>
                        </TableRow>
                    </TableBody>
                </Table>
            </Box>
            <Box className='mt-5 mx-2 pt-3'>
                <Typography className='text-center' variant='h4'>Pending Allocations</Typography>
                <Table className='mt-3' sx={{ borderRadius: '10px' }}>
                    <TableHead sx={{ bgcolor: "#7a7d52" }}>
                        <TableRow>
                            <TableCell sx={{ color: "white", fontWeight: 'bold' }}>Venue Name</TableCell>
                            <TableCell sx={{ color: "white", fontWeight: 'bold', textAlign: 'center' }}>Group Name</TableCell>
                            <TableCell sx={{ color: "white", fontWeight: 'bold', textAlign: 'center' }}>Site Type</TableCell>
                            <TableCell sx={{ color: "white", fontWeight: 'bold', textAlign: 'center' }}>Status</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {
                            allocationTable.length > 0 ? (allocationTable?.map((item: any, index) => (
                                <TableRow key={index}>
                                    <TableCell>{item?.venueId?.venueName}</TableCell>
                                    <TableCell sx={{ textAlign: 'center' }}>{item?.allocationClientGroup}</TableCell>
                                    <TableCell sx={{ textAlign: 'center' }}>{item?.venueId?.shopTypeId?.shopTypeName}</TableCell>
                                    <TableCell sx={{ textAlign: 'center' }}>{Status()}</TableCell>
                                </TableRow>

                            ))) : <TableCell colSpan={4} className='text-center'><Typography>No Data Found</Typography></TableCell>
                        }
                    </TableBody>
                </Table>
                <TablePagination
                    rowsPerPageOptions={[5, 10, 25, 50]}
                    component="div"
                    count={datalength}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                />
            </Box>

            <Dialog open={OpenRoasterDownload} onClose={() => { setOpenRoasterDownload(false) }}
                PaperProps={{
                    sx: {
                        borderRadius: "10px",
                        width: "clamp(300px, 24%, 700px)",
                    },
                }}>
                <Box>
                    <Box className=' px-3 py-2  d-flex align-items-center justify-content-between'>
                        <Typography variant='h6'>Download Settings</Typography>
                        <IconButton onClick={() => { setOpenRoasterDownload(false) }}><CancelOutlined /></IconButton>
                    </Box>
                    <hr className='my-0' />
                    <Box className='px-3 py-2'>
                        <FormControl component="fieldset">
                            <RadioGroup
                                aria-label="options"
                                name="options"
                                value={selectedOption}
                                onChange={(e) => { setselectedOption(e.target.value) }}
                            >
                                <FormControlLabel value="false" control={<Radio color='danger' />} label="Download All Data" />
                                <FormControlLabel value="true" control={<Radio color='danger' />} label="Only Name and Number" />
                            </RadioGroup>
                        </FormControl>
                    </Box>
                    <Box className='px-3 pb-2'>
                        <Button fullWidth onClick={() => { handledownloadRoaster() }} className="text-light action-button action-button--approve table-row-background">Download</Button>
                    </Box>
                </Box>
            </Dialog>
        </div>

    )
}

export default ImportExportAllocations
